import { render } from "./circleLoad.vue?vue&type=template&id=52d2fb88&scoped=true"
import script from "./circleLoad.vue?vue&type=script&lang=js"
export * from "./circleLoad.vue?vue&type=script&lang=js"

import "./circleLoad.vue?vue&type=style&index=0&id=52d2fb88&lang=less&scoped=true"

import exportComponent from "D:\\Website desing\\kkiokio\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52d2fb88"]])

export default __exports__